import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

export const BackButton = styled(Link)`
  font-size: 18px;
  font-weight: bolder;
  color: var(--bg-button-default-color);

  &:focus,
  &:hover {
    color: var(--button-hover-color);
    cursor: pointer;
    transition: 0.4s;
  }
`;

export const StyledButton = styled(Button)`
  min-width: 125px;
  height: 40px;
  margin: 10px;
  border-radius: 5px;
  background: var(--bg-button-default-color);
  font-family: 'Segoe UI';
  font-size: 16px;
  color: var(--button-text-color);
  &:hover {
    background-color: var(--button-hover-color) !important;
    border-color: var(--button-hover-color);
    cursor: pointer;
  }
  &.af-superadmin-template-editbox-content-button {
    margin-top: ${(props) => (props.$expiry_notify ? '24px' : '0px')};
  }
  &.af-superadmin-api-settings-api-route-wrap-input-edit-submit {
    height: 35px;
    min-width: 60px;
    font-size: 15px;
  }
`;
export const ThemedButton = styled(Button)`
  min-width: 80px;
  border-radius: 5px;
  border-width: 1px;
  border-color: var(--bg-button-default-color);
  font-family: 'Segoe UI';
  color: var(--bg-button-default-color);
  padding: 0px 10px 0px 10px !important;
  &:hover {
    border-color: var(--button-hover-color) !important;
    color: var(--button-hover-color) !important;
    cursor: pointer;
  }
  &.adminButton {
    min-width: 100px;
    height: 35px;
    border-width: 2px;
    border-style: solid;
    font-size: 14px;
    padding: unset;
  }
  &.test_mail {
    height: 35px;
    padding: unset;
    margin-left: '10px';
  }
  &.af-superadmin-api-settings-api-route-theme-button {
    height: 35px;
    min-width: 60px;
    font-size: 15px;
  }
`;
